export const flatten = <T>(arr: T[][], depth = 1): T[] =>
  arr.reduce(
    (a, v) => a.concat(depth > 1 && Array.isArray(v) ? flatten<T>(v as any, depth - 1) : v),
    [] as T[]
  );

export const groupBy = <T>(arr: T[], fn: (item: T) => string): { [key: string]: T[] } =>
  arr.map(fn).reduce((acc, val, i) => {
    acc[val] = (acc[val] || []).concat(arr[i]);
    return acc;
  }, {} as { [key: string]: any });

/**
 * 連続する呼び出しに対してwaitミリ秒間に1回の実行に制限。delayミリ秒の遅延を設定可能。
 * @param fn
 * @param wait
 * @param delay
 * @example let throttledFunc = throttle(myFunc, 2000, 200);
 */
export function throttle(fn: (..._: any) => any, wait: number, delay = 0) {
  let isCalled = false;
  return (...args: any) => {
    if (!isCalled) {
      setTimeout(fn, delay, ...args);
      isCalled = true;
      setTimeout(() => {
        isCalled = false;
      }, wait);
    }
  };
}

export function getQueryParam(qs: string, key: string): string | undefined {
  // URLSearchParams is only supported by Safari 10.3+ and Chrome 49+
  if (window.URLSearchParams) {
    return new URLSearchParams(qs).get(key) || undefined;
  } else {
    let half = qs.split(`&${key}=`)[1];
    if (!half) {
      half = qs.split(`?${key}=`)[1];
    }
    return half !== undefined ? decodeURIComponent(half.split('&')[0]) : undefined;
  }
}

// helper function
export function parseNumString(numStr: string) {
  const parsed = parseInt(numStr, 10);

  if (isNaN(parsed)) {
    return undefined;
  }
  return parsed;
}

export const shuffle = <T>(arr: T[]) => {
  let m = arr.length;
  while (m) {
    const i = Math.floor(Math.random() * m--);
    [arr[m], arr[i]] = [arr[i], arr[m]];
  }
  return arr;
};

export function replaceAllSpaces(message: string) {
  return message.replace(/\u0020/g, '\u2004');
}

export const chunk = <T>(arr: T[], size: number): T[][] =>
  Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
    arr.slice(i * size, i * size + size)
  );
